import FilterTagArea from './elements/FilterTagArea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectTemplatesAndCombinedOntology } from '../../data/templateSlice';
import TemplatesAccordionMenu from './elements/TemplatesAccordionMenu';
import styles from './Settings.module.scss';
import { TemplateOverview } from './elements/TemplateOverview';
import { useAppSelector, useUser } from '../../app/hooks';
import { useEffect, useRef, useState } from 'react';
import { OntologyDiagam } from './ontology-diagram/OntologyDiagram';

function SettingsSectionButton({
  name,
  id,
  activeSectionId,
  setActiveSectionId,
}: {
  name: string;
  id: string;
  activeSectionId: string;
  setActiveSectionId: (id: string) => void;
}) {
  return (
    <button
      className={activeSectionId == id ? styles.settingsTitleButtonActive : styles.settingsTitleButton}
      onClick={() => setActiveSectionId(id)}
    >
      {name}
    </button>
  );
}

export function Settings() {
  const { templates } = useAppSelector(selectTemplatesAndCombinedOntology);
  const refTemplateGrid = useRef<HTMLDivElement>(null);
  const { user } = useUser();

  const [activeSectionId, setActiveSectionId] = useState<string>('');
  const [scopes, setScopes] = useState<string[]>([]);
  const [scopeValue, setScopeValue] = useState<string>('assetViews');
  const [selectedTemplateTypeTag, setSelectedTemplateTypeTag] = useState<string>('');

  useEffect(() => {
    setScopes(
      Object.keys(templates).filter(
        (scope) => scope !== 'taskTemplates' && scope !== 'invalidTemplates' && templates[scope],
      ),
    );
  }, []);

  if (templates && scopes.length != 0) {
    return (
      <>
        <div className={styles.wrapper}>
          <div className={styles.settingsChartWrapper}>
            <h1 className={styles.settingsMenuHeader}>Settings</h1>
            <div className={styles.settingsSeparator} />
            <SettingsSectionButton
              name="Ontology diagram"
              id="ontologyDiagram"
              activeSectionId={activeSectionId}
              setActiveSectionId={setActiveSectionId}
            />
            {user.isOrganizationAdmin && (
              <>
                <div className={styles.settingsSectionSeparator} />

                <TemplatesAccordionMenu
                  scopes={scopes}
                  scopeValue={scopeValue}
                  setScopeValue={setScopeValue}
                  activeSectionId={activeSectionId}
                  setActiveSectionId={setActiveSectionId}
                  invalidTemplates={templates.invalidTemplates}
                />
              </>
            )}
          </div>

          <div className={styles.searchAndAssetWrapper}>
            {activeSectionId == 'ontologyDiagram' && ( // Ontology diagram section
              <OntologyDiagam />
            )}

            {activeSectionId == 'templates' && ( // Templates section
              <>
                <div className={styles.searchArea}>
                  <FilterTagArea
                    scopeValue={scopeValue}
                    selectedTemplateTypeTag={selectedTemplateTypeTag}
                    setSelectedTemplateTypeTag={setSelectedTemplateTypeTag}
                  />
                </div>
                <div className={styles.separator} />

                <div ref={refTemplateGrid}>
                  <TemplateOverview
                    scopeValue={scopeValue}
                    refTemplateGrid={refTemplateGrid}
                    selectedTemplateTypeTag={selectedTemplateTypeTag}
                    setSelectedTemplateTypeTag={setSelectedTemplateTypeTag}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="spinnerWrapper">
        <FontAwesomeIcon icon={['fas', 'spinner']} spin className="spinner" />
      </div>
    );
  }
}
